<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<div class="card distribution">
					<h2>Распределение заказов Основной отдел</h2>
					<b-alert :show="showAlertError" variant="danger"></b-alert>
					<b-alert :show="showAlertSuccess" variant="success"></b-alert>
					<div class="card-body" v-if="isload == true">
						<vuetable
							ref="vuetable"
							:api-mode="false"
							:fields="columns"
							:data="itemActions"
							noDataTemplate="Ничего не найдено"
							class="table-striped table table-striped table-bordered table-hovered table-responsive-sm"
						>
							<template slot="prod2" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod2"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod3" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod3"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod4" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod4"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod5" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod5"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod6" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod6"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod7" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod7"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod8" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod8"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod9" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod9"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod10" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod10"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod11" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod11"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod12" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod12"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod13" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod13"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod14" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod14"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod15" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod15"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod16" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod16"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod16" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod16"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod17" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod17"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
							<template slot="prod18" slot-scope="props">
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input
										type="checkbox"
										class="switch-input"
										@change="onChangeStatus()"
										v-model="props.rowData.prod18"
									/>
									<span class="switch-slider"></span>
								</label>
							</template>
						</vuetable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showAlertError: false,
			showAlertSuccess: false,
			denyaccess: false,
			selectedUser: null,
			isload: false,
			columns: [
				{
					name: "user",
					title: "Менеджер"
				}
			],
			itemActions: []
		};
	},
	created() {
		this.getEvent();
		this.onChangeTime();
	},
	methods: {
		getEvent() {
			this.$store.commit("CALL_API_ON");
			this.$http
				.get(this.$store.state.apiURL + "/v1/order/distributions", {}, {})
				.then(
					function(response) {
						this.isload = true;
						this.denyaccess = response.body.deny_access;
						var user = response.body.user;
						var product = response.body.product_name;
						console.log(product);
						for (var userkey in user) {
							this.itemActions.push({
								id: user[userkey].user_id,
								user: user[userkey].name,
								prod2: user[userkey].product_id.includes("a"),
								prod3: user[userkey].product_id.includes("b"),
								prod4: user[userkey].product_id.includes("c"),
								prod5: user[userkey].product_id.includes("d"),
								prod6: user[userkey].product_id.includes("e"),
								prod7: user[userkey].product_id.includes("f"),
								prod8: user[userkey].product_id.includes("g"),
								prod9: user[userkey].product_id.includes("h"),
								prod10: user[userkey].product_id.includes("i"),
								prod11: user[userkey].product_id.includes("j"),
								prod12: user[userkey].product_id.includes("k"),
								prod13: user[userkey].product_id.includes("l"),
								prod14: user[userkey].product_id.includes("m"),
								prod15: user[userkey].product_id.includes("n"),
								prod16: user[userkey].product_id.includes("o"),
								prod17: user[userkey].product_id.includes("p"),
								prod18: user[userkey].product_id.includes("r")
							});
						}
						for (var key in product) {
							if (key != 13) {
								this.columns.push({
									name: `__slot:prod${key}`,
									title: product[key]
								});
							}
						}
						this.$store.commit("CALL_API_OFF");
					},
					function(response) {}
				);
		},
		onChangeStatus() {
			if (this.denyaccess) {
				this.$store.commit("CALL_API_ON");
				this.$http
					.post(
						this.$store.state.apiURL + "/v1/order/distributions",
						this.itemActions,
						{},
						{}
					)
					.then(
						function(response) {
							this.$notify({
								group: "default",
								type: "success",
								text: "Данные обновлены "
							});
							this.$store.commit("CALL_API_OFF");
						},
						function(response) {
							this.$notify({
								group: "default",
								type: "danger",
								text: "Данные не обновлены"
							});
						}
					);
			} else {
				this.$notify({
					group: "default",
					type: "danger",
					text: "Для обновления данных повысьте привилегии"
				});
			}
		},
		onChangeTime() {
			setInterval(() => {
				var elems = document.querySelectorAll("input[type=checkbox]");
				elems.forEach(params => {
					params.closest("td").bgColor = "";
				});
				var elem = document.querySelectorAll("input[type=checkbox]:checked");
				elem.forEach(param => {
					param.closest("td").bgColor = "#06b306";
				});
			});
		}
	}
};
</script>

<style>
.distribution .vuetable-body td:nth-child(1) {
	font-size: 0.875rem;
	font-weight: 700;
	text-align: left;
}
.distribution .vuetable-body,
h2 {
	text-align: center;
}

.distribution h2 {
	font-size: 2.5em;
}

.distribution thead {
	font-size: 0.875rem;
}

.distribution tr > *:nth-child(4) {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/distribution/index.vue